import React from 'react';
import { Container, Button, Col, Row, HeadingText, BodyText } from '@paypalcorp/pp-react';
import { getCdnHostName } from '@paypalcorp/instance-location';
import withTheme from '../../common/withTheme';

class Success extends React.Component {
    render() {
        return (
            <Container>
                <Row>
                    <Col style={{ textAlign: "center" }}>
                        <div><img src={`https://${getCdnHostName()}/paypal-ui/illustrations/focused/svg/empty-success.svg`} style={{ width: '120px' }} alt={this.props.successImgText} /></div>
                        <HeadingText size="sm">{this.props.header}</HeadingText>
                        <BodyText as='p'>{this.props.bodyContent}</BodyText>
                        <Button as={this.props.buttonInfo.as} href={this.props.buttonInfo.url}>{this.props.buttonInfo.text}</Button>
                    </Col>
                </Row>
            </Container>
        )
    }
}
export default withTheme(Success);